var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgWarning24 = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.946,
    d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.219 7.194a1.165 1.165 0 1 0-2.33.002l.18 6.61h1.986l.164-6.612Zm-2.52 9.126a1.367 1.367 0 0 0 1.371 1.37c.73 0 1.354-.615 1.354-1.37 0-.739-.624-1.345-1.354-1.354-.755.009-1.38.615-1.37 1.354Z"
  })));
});
SvgWarning24.displayName = "SvgWarning24";
export default SvgWarning24;